/* Novaris cart-only behavior patch — 18 Sep 2026 */
(function(){
  'use strict';
  if(window.NovarisCartOnlyPatch) return;
  window.NovarisCartOnlyPatch={version:'2.0.0'};

  function visibleCartLink(){
    var links=Array.prototype.slice.call(document.querySelectorAll('a.js-drawer-open-cart'));
    return links.find(function(el){
      if(!el||!el.isConnected) return false;
      var r=el.getBoundingClientRect();
      var st=window.getComputedStyle(el);
      return r.width>0&&r.height>0&&st.display!=='none'&&st.visibility!=='hidden';
    })||links[0]||null;
  }

  function pulseCart(link){
    if(!link) return;
    link.classList.remove('nv-cart-pulse');
    void link.offsetWidth;
    link.classList.add('nv-cart-pulse');
    window.setTimeout(function(){link.classList.remove('nv-cart-pulse');},520);
  }

  function flyToCart(sourceButton){
    var target=visibleCartLink();
    if(!target) return;
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches){pulseCart(target);return;}
    var tr=target.getBoundingClientRect();
    if(!tr.width||!tr.height) return;
    var sr=sourceButton&&sourceButton.getBoundingClientRect?sourceButton.getBoundingClientRect():null;
    var sx=sr&&sr.width?sr.left+sr.width/2:window.innerWidth/2;
    var sy=sr&&sr.height?sr.top+sr.height/2:window.innerHeight*.72;
    var ex=tr.left+tr.width/2, ey=tr.top+tr.height/2;
    var dot=document.createElement('span');
    dot.className='nv-cart-fly-dot';
    dot.setAttribute('aria-hidden','true');
    dot.style.left=(sx-8)+'px';dot.style.top=(sy-8)+'px';
    document.body.appendChild(dot);
    if(!dot.animate){dot.remove();pulseCart(target);return;}
    var dx=ex-sx,dy=ey-sy;
    var a=dot.animate([
      {transform:'translate3d(0,0,0) scale(1)',opacity:1},
      {transform:'translate3d('+(dx*.56)+'px,'+(dy*.42-44)+'px,0) scale(.9)',opacity:.95,offset:.58},
      {transform:'translate3d('+dx+'px,'+dy+'px,0) scale(.25)',opacity:.1}
    ],{duration:920,easing:'cubic-bezier(.2,.75,.25,1)',fill:'forwards'});
    a.onfinish=function(){dot.remove();pulseCart(target);};
    a.oncancel=function(){dot.remove();};
  }

  var toastTimer=0;

  function showAddedToast(){
    var toast=document.querySelector('[data-nv-cart-toast]');
    if(!toast){
      toast=document.createElement('div');
      toast.className='nv-cart-toast';
      toast.setAttribute('data-nv-cart-toast','');
      toast.setAttribute('role','status');
      toast.setAttribute('aria-live','polite');
      toast.textContent='Se agregó al carrito';
      document.body.appendChild(toast);
    }

    window.clearTimeout(toastTimer);
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');

    toastTimer=window.setTimeout(function(){
      toast.classList.remove('is-visible');
    },1650);
  }

  function beginOptimisticRemoval(item){
    if(!item||item.classList.contains('nv-cart-item--removing')) return null;
    var state={
      height:item.style.height,
      overflow:item.style.overflow,
      pointerEvents:item.style.pointerEvents
    };
    var rect=item.getBoundingClientRect();
    item.style.height=Math.max(0,rect.height)+'px';
    item.style.overflow='hidden';
    item.style.pointerEvents='none';
    // Force the browser to register the starting height before collapsing.
    void item.offsetHeight;
    item.classList.add('nv-cart-item--removing');
    window.requestAnimationFrame(function(){
      item.style.height='0px';
    });
    return state;
  }

  function rollbackOptimisticRemoval(item,state){
    if(!item) return;
    item.classList.remove('nv-cart-item--removing');
    item.style.height=state&&typeof state.height==='string'?state.height:'';
    item.style.overflow=state&&typeof state.overflow==='string'?state.overflow:'';
    item.style.pointerEvents=state&&typeof state.pointerEvents==='string'?state.pointerEvents:'';
  }

  function updateCartSummary(cart){
    if(!cart) return;
    var count=Math.max(0,Number(cart.item_count)||0);
    document.querySelectorAll('.cart-link__bubble-num').forEach(function(el){el.textContent=String(count);});
    document.querySelectorAll('.cart-link__bubble').forEach(function(el){
      el.classList.toggle('cart-link__bubble--visible',count>0);
    });
    if(typeof cart.total_price!=='undefined'&&window.theme&&theme.Currency){
      var subtotal=theme.Currency.formatMoney(cart.total_price,theme.settings&&theme.settings.moneyFormat);
      document.querySelectorAll('[data-subtotal]').forEach(function(el){el.innerHTML=subtotal;});
    }
  }

  var pendingRemovals=new Map();
  var removalRequestActive=false;
  var flushTimer=0;
  var rebuildTimer=0;

  function cartUpdateRoute(){
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    if(root.charAt(root.length-1)!=='/') root+='/';
    return root+'cart/update.js';
  }

  function drawerElement(){
    return document.getElementById('CartDrawer');
  }

  function remainingVisibleItemCount(){
    var drawer=drawerElement();
    if(!drawer) return 0;
    return drawer.querySelectorAll('.cart__item:not(.nv-cart-item--removing)').length;
  }

  function remainingVisibleUnitCount(){
    var drawer=drawerElement();
    if(!drawer) return 0;
    var total=0;
    drawer.querySelectorAll('.cart__item:not(.nv-cart-item--removing) .js-qty__num').forEach(function(input){
      total+=Math.max(0,Number(input.value)||0);
    });
    return total;
  }

  function setOptimisticCount(count){
    count=Math.max(0,Number(count)||0);
    document.querySelectorAll('.cart-link__bubble-num').forEach(function(el){el.textContent=String(count);});
    document.querySelectorAll('.cart-link__bubble').forEach(function(el){
      el.classList.toggle('cart-link__bubble--visible',count>0);
    });
  }

  function setDrawerEmptyState(empty){
    var drawer=drawerElement();
    if(drawer) drawer.classList.toggle('is-empty',!!empty);
  }

  function scheduleAuthoritativeRebuild(delay){
    window.clearTimeout(rebuildTimer);
    rebuildTimer=window.setTimeout(function(){
      if(removalRequestActive||pendingRemovals.size) return;
      document.dispatchEvent(new CustomEvent('cart:build'));
    },typeof delay==='number'?delay:140);
  }

  function rollbackBatch(entries){
    entries.forEach(function(entry){
      rollbackOptimisticRemoval(entry.item,entry.visualState);
      if(entry.link) entry.link.removeAttribute('aria-busy');
    });
    setDrawerEmptyState(false);
    setOptimisticCount(remainingVisibleUnitCount());
  }

  function flushRemovals(){
    window.clearTimeout(flushTimer);
    flushTimer=0;
    if(removalRequestActive||!pendingRemovals.size) return;

    var entries=Array.from(pendingRemovals.values());
    pendingRemovals.clear();
    removalRequestActive=true;
    document.dispatchEvent(new CustomEvent('cart:invalidate-build'));

    var updates={};
    entries.forEach(function(entry){updates[entry.key]=0;});

    fetch(cartUpdateRoute(),{
      method:'POST',
      credentials:'same-origin',
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json',
        'X-Requested-With':'XMLHttpRequest'
      },
      body:JSON.stringify({updates:updates})
    }).then(function(response){
      return response.json().then(function(cart){
        if(!response.ok){
          var error=new Error((cart&&cart.description)||(cart&&cart.message)||'No se pudo actualizar el carrito.');
          error.payload=cart;
          throw error;
        }
        return cart;
      });
    }).then(function(cart){
      updateCartSummary(cart);
      setDrawerEmptyState(Number(cart.item_count)===0);
      document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart}}));

      // Close as soon as Shopify confirms an empty cart. If the drawer was
      // optimistically closed already this is a harmless no-op.
      if(Number(cart.item_count)===0){
        document.dispatchEvent(new CustomEvent('cart:close'));
      }
    }).catch(function(error){
      rollbackBatch(entries);
      document.dispatchEvent(new CustomEvent('ajaxProduct:error',{detail:{
        errorMessage:(error&&error.message)||'No se pudo eliminar el producto. Inténtalo nuevamente.'
      }}));

      // If we optimistically closed the drawer because the last visible line
      // was removed, reopen it so the restored item is not hidden from the user.
      if(entries.some(function(entry){return entry.optimisticallyClosed;})){
        document.dispatchEvent(new CustomEvent('cart:open'));
      }
    }).finally(function(){
      entries.forEach(function(entry){
        if(entry.link) entry.link.removeAttribute('aria-busy');
      });
      removalRequestActive=false;
      if(pendingRemovals.size){
        scheduleFlush(0);
      }else{
        // Refresh discounts/remaining line prices in the background only after
        // all rapid removals have finished. This no longer blocks the UI.
        scheduleAuthoritativeRebuild(100);
      }
    });
  }

  function scheduleFlush(delay){
    window.clearTimeout(flushTimer);
    flushTimer=window.setTimeout(flushRemovals,typeof delay==='number'?delay:55);
  }

  function removeItem(link){
    if(!link||link.getAttribute('aria-busy')==='true') return;
    var item=link.closest('.cart__item');
    var key=link.getAttribute('data-cart-key')||(item&&item.getAttribute('data-key'));
    if(!key||pendingRemovals.has(key)) return;

    window.clearTimeout(rebuildTimer);
    document.dispatchEvent(new CustomEvent('cart:invalidate-build'));

    link.setAttribute('aria-busy','true');
    var visualState=beginOptimisticRemoval(item);
    var noVisibleItems=remainingVisibleItemCount()===0;

    // Keep the cart badge responsive before the network round-trip.
    setOptimisticCount(remainingVisibleUnitCount());

    // If this was the final visible line, close immediately instead of waiting
    // for Shopify + a drawer rebuild. A failed request reopens it in rollback.
    if(noVisibleItems){
      setDrawerEmptyState(true);
      document.querySelectorAll('[data-subtotal]').forEach(function(el){
        if(window.theme&&theme.Currency){
          el.innerHTML=theme.Currency.formatMoney(0,theme.settings&&theme.settings.moneyFormat);
        }
      });
      document.dispatchEvent(new CustomEvent('cart:close'));
    }

    pendingRemovals.set(key,{
      link:link,
      item:item,
      key:key,
      visualState:visualState,
      optimisticallyClosed:noVisibleItems
    });
    scheduleFlush();
  }

  var addedCartObserver=null;
  var addedCartTimer=0;
  document.addEventListener('ajaxProduct:added',function(){
    var drawer=drawerElement();
    if(!drawer) return;
    var products=drawer.querySelector('[data-products]');
    if(addedCartObserver) addedCartObserver.disconnect();
    window.clearTimeout(addedCartTimer);
    function openAddedCart(){
      if(addedCartObserver) addedCartObserver.disconnect();
      addedCartObserver=null;
      window.clearTimeout(addedCartTimer);
      document.dispatchEvent(new CustomEvent('cart:open'));
    }
    // The theme rebuilds the drawer after an AJAX add. Open when the new items
    // are rendered, after the independent selector has released its focus.
    if(products){
      addedCartObserver=new MutationObserver(function(){
        window.requestAnimationFrame(openAddedCart);
      });
      addedCartObserver.observe(products,{childList:true});
    }
    // Keep the cart reachable if a slow or failed markup refresh delays it.
    addedCartTimer=window.setTimeout(openAddedCart,2500);
  });

  document.addEventListener('click',function(event){
    var target=event.target&&event.target.closest?event.target.closest('[data-nv-remove-item]'):null;
    if(!target) return;
    // Prevent the anchor fallback from ever navigating to /cart/change while
    // JavaScript is active. This removes the intermittent full-page reload.
    event.preventDefault();
    event.stopPropagation();
    removeItem(target);
  },true);
})();
